import React from "react";

import { Flex, Spinner } from "@chakra-ui/react";
import Invite from "./invite";
import colors from "app/colors";
import useQueryString from "modules/hooks/use-query-string";

const InvitePage = () => {
  const { qsInviteId } = useQueryString();

  if (!qsInviteId) {
    return <Spinner />;
  }

  return (
    <Flex
      h="100dvh"
      bg={colors.darkBlue}
      alignItems="center"
      justifyContent="center"
    >
      <Invite inviteId={qsInviteId} />
    </Flex>
  );
};

InvitePage.prefersFullScreenLayout = true;

export default InvitePage;
